import type {
  OrganizationRepository,
  OrganizationListOptions,
  OrganizationPage,
} from '#/domain/organization/OrganizationRepository'
import type { Organization } from '#/domain/organization/Organization'
import type { HttpClientPort } from '#/infrastructure/persistence/HttpClientPort'
import { objectToFormData } from '#/infrastructure/persistence/objectToFormData'
import {
  toDomain,
  toDomainFindById,
  toDomainPage,
  type OrganizationResponseDto,
  type OrganizationPageResponseDto,
} from './OrganizationDto'

export class HttpOrganizationRepository implements OrganizationRepository {
  constructor(private readonly http: HttpClientPort) {}

  async findAll(options: OrganizationListOptions): Promise<OrganizationPage> {
    const searchParams = new URLSearchParams({
      page: String(options.page),
      itemsPerPage: String(options.itemsPerPage),
    })
    const raw = await this.http.get<OrganizationPageResponseDto>('auth0/organization', {
      searchParams,
    })
    return toDomainPage(raw)
  }

  async findById(id: string): Promise<Organization> {
    const raw = await this.http.get<OrganizationResponseDto>(`auth0/organization/${id}`)
    return toDomainFindById(raw)
  }

  async create(organization: Organization): Promise<Organization> {
    const raw = await this.http.post<OrganizationResponseDto>('auth0/organization', {
      body: objectToFormData(organization),
    })
    return toDomain(raw)
  }

  async update(organization: Organization): Promise<Organization> {
    const raw = await this.http.patch<OrganizationResponseDto>('auth0/organization', {
      body: objectToFormData(organization),
    })
    return toDomain(raw)
  }

  remove(id: string): Promise<void> {
    return this.http.delete<void>(`auth0/organization/${id}`)
  }
}
